module.exports = __webpack_public_path__ + "static/media/3.3 KC Tribunj 3-14.08.2025..12b07cc2.png";